import { Component, ChangeDetectionStrategy } from "@angular/core";

import { TranslatePipe } from "@ngx-translate/core";
import { VERSION } from "@angular/material/core";

@Component({
  selector: "app-footer",
  imports: [TranslatePipe],
  templateUrl: "./footer.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent {
  isNextVersion = location.hostname === "next.material.angular.io";
  version = VERSION.full;
  year = new Date().getFullYear();
}
